/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EvidenceItemSource = typeof EvidenceItemSource[keyof typeof EvidenceItemSource];


export const EvidenceItemSource = {
  identity: 'identity',
  headline: 'headline',
  summary: 'summary',
  experience: 'experience',
  education: 'education',
  skills: 'skills',
  certifications: 'certifications',
  languages: 'languages',
} as const;
